<template>
  <div class="payment">
    <div style="padding-bottom:106px">
      <Title text="订单确认" />
      <div class="choose-address" @click="toAddress">
        <!-- 没有地址时 -->
        <div class="no-address" v-if="addressShow">
          <div>
            <p>请选择收货地址</p>
            <p>(收货不便时，可选择自提服务)</p>
          </div>
        </div>
        <!-- 有地址时 -->
        <div v-if="!addressShow">
          <div class="address-content">
            <p class="name">{{address.receiver}} {{address.phone}}</p>
            <p
              class="address"
            >{{address.provinceName}}{{address.cityName}}{{address.areaName}}{{address.address}}</p>
            <p class="self-mention" v-if="isShow">(收货不便时，可选择自提服务)</p>
            <p class="self-mention" v-if="!isShow">支付成功后，请到自提点拿货</p>
          </div>
          <div class="right-icon">
            <img src="../assets/images/right.png" alt />
          </div>
          <div class="bottom-icon">
            <img src="../assets/images/order/dizhilan@2x.png" alt />
          </div>
        </div>
      </div>
      <!-- 商品列表 -->
      <div class="product-list">
        <van-card
          :num="item.qty"
          :price="item.price"
          :title="item.model"
          :thumb="item.imgAddress"
          v-for="(item,index) in productList"
          :key="index"
          @click="$router.push({name:'productDetails',query:{productId:item.stockId}})"
        >
          <div slot="desc" class="brand">
            <p>品牌：{{item.brand}}</p>
            <p>封装规格：{{item.pack}}</p>
          </div>
        </van-card>
      </div>
      <!-- 发票 -->
      <div class="choose-invoice" @click="toInvoice">
        <span>发票</span>
        <div class="icon">
          <img src="../assets/images/right.png" alt />
        </div>
        <!-- <P v-if="invoiceFalge">{{`增值锐发票-${invoice.invoiceTitle}`}}</P> -->
        <P>{{invoiceText}}</P>
      </div>
      <!-- 买家留言 -->
      <div class="leave-comments">
        <span>买家留言</span>
        <input type="text" placeholder="填写对本次交易的说明（100字符）" v-model="remark" />
      </div>
      <!-- 商品金额加运费 -->
      <div class="price-wrap">
        <ul>
          <li>
            <p>商品金额</p>
            <span>￥{{total | moneyFilter}}</span>
          </li>
          <li>
            <p>运费</p>
            <span>+￥{{freight | moneyFilter}}</span>
          </li>
        </ul>
        <p class="total">
          总计：
          <span>￥{{total + freight | moneyFilter}}</span>
        </p>
      </div>
      <!-- 支付方式 -->
      <div class="chosse-payment">
        <ul>
          <li v-for="(item,index) in paymentList" :key="index" @click="paymentChoose(item,index)">
            <div class="type-icon">
              <img :src="item.img" alt />
            </div>
            <span>{{item.text}}</span>
            <div class="radio-icon">
              <img src="../assets/images/order/xuanzeh@2x.png" alt v-show="current == index" />
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 底部 -->
    <div class="payment-footer">
      <p>
        实付金额：
        <span>￥{{total + freight | moneyFilter}}</span>
      </p>
      <button @click="orderCreate">立即支付</button>
    </div>
  </div>
</template>

<script>
import Title from "../components/Title";
import {
  shopCartSettle,
  MemAddress,
  MemInvoice,
  OrderCreate
} from "../request/api";
import { toMoney } from "../common/moneyFilter";
export default {
  name: "payment",
  data() {
    return {
      addressShow: true,
      isShow: true, //地址提示显示
      activeImg: require("../assets/images/order/xuanzeh@2x.png"),
      productList: [],
      address: {}, //地址
      invoice: {}, //发票
      shopId: [], //购物车id
      invoiceFalge: null, //发票文字显示
      invoiceText: "请选择",
      remark: "", //，买家留言
      totalPrice: "", //商品总金额
      freightPrice: 0, //运费金额
      current: 0, //支付方式index
      payment: "ALIPAY", //支付方式
      paymentList: [
        {
          img: require("../assets/images/order/order_img_zaixianzf@2x.png"),
          text: "在线支付",
          type: "ALIPAY"
        },
        {
          img: require("../assets/images/order/xianxia.png"),
          text: "线下支付",
          type: "UNDERLINE"
        }
      ]
    };
  },
  created() {
    this.getSettleShop();
    this.getAddress();
    this.getInvoice();
  },
  components: {
    Title
  },
  filters: {
    moneyFilter(money) {
      return toMoney(money);
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "payment") {
      // 这个name是下一级页面的路由name
      to.meta.isBack = true; // 设置为true说明你是返回到这个页面，而不是通过跳转从其他页面进入到这个页面
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      this.getAddress();
      this.getInvoice();
      this.getSettleShop();
      // 这里发起数据请求，（之前是放在created或者mounted中，现在只需要放在这里就好了，不需要再在created或者mounted中请求！！）
    }
  },
  methods: {
    //获取结算订单信息
    getSettleShop() {
      let ids = JSON.parse(sessionStorage.getItem("shopId"));
      if (ids != null) {
        shopCartSettle(ids).then(res => {
          if (res.status == 200) {
            this.productList = res.data;
          } else if (res.status == 202) {
            this.$toast({
              message: res.msg,
              duration: 1000
            });
            this.$router.back(-1);
          }
        });
      } else {
        this.$toast("订单发生改变，请重新选择");
        this.$router.push("/home");
      }
      //判断是否是选择的自提
      if (this.$route.params.isLifting) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    //获取地址列表
    getAddress() {
      let address = sessionStorage.getItem("address");
      if (address != null) {
        this.address = JSON.parse(address);
        this.addressShow = false;
      } else {
        MemAddress({}).then(res => {
          if (res.data.length <= 0) {
            this.addressShow = true;
          } else {
            res.data.forEach(el => {
              if (el.defaultFlag) {
                this.address = el;
                this.addressShow = false;
              }
            });
          }
        });
      }
    },
    //获取发票信息
    getInvoice() {
      //判断是否开具发票
      this.invoiceText = sessionStorage.getItem("invoice");
      if (this.invoiceText != null) {
        if (this.invoiceText == "不需要发票") {
          this.invoiceFalge = false;
        } else {
          this.invoiceFalge = true;
        }
      } else {
        this.invoiceText = '请选择'
      }
      // else {
      //   MemInvoice({}).then(res => {
      //     if (res.data != null) {
      //       this.invoiceFalge = true;
      //     } else {
      //       this.invoiceFalge = false;
      //     }
      //   });
      // }
    },
    //跳转至地址列表
    toAddress() {
      this.$router.push({
        name: "address",
        params: {
          type: "choose"
        }
      });
    },
    //跳转到发票页面
    toInvoice() {
      this.$router.push({
        name: "invoice",
        params: {
          type: "choose"
        }
      });
    },
    //选择支付类型
    paymentChoose(item, index) {
      this.current = index;
      //支付方式
      this.payment = this.current == 0 ? "ALIPAY" : "UNDERLINE";
    },

    //立即支付生成订单
    orderCreate() {
      let deliveryType = "";
      let paymentId = this.$route.params.paymentId;
      let ids = JSON.parse(sessionStorage.getItem("shopId"));
      //地址不能为空
      if (this.address == undefined) {
        this.$toast("请选择收货地址");
        return;
      }
      //订单号不能为空
      if (ids == null || ids == undefined) {
        this.$toast("还没有待结算的商品");
        return;
      }
      //发票选择不能为空
      if (this.invoiceFalge == null) {
        this.$toast("请选择发票类型");
        return;
      }
      //配送方式
      deliveryType = this.address.lifiting
        ? "SELF_LIFTING"
        : "EXPRESS_DELIVERY";
      let data = {
        deliveryType: deliveryType,
        addressId: this.address.id,
        remark: this.remark,
        invoiceStatus: this.invoiceFalge,
        payType: this.payment,
        cartIds: ids
      };
      //线上支付
      if (this.payment == "ALIPAY") {
        OrderCreate(data).then(res => {
          if (res.status == 200) {
            this.$router.push({
              name: "alipy",
              query: {
                sno: res.data
              }
            });
            sessionStorage.removeItem("shopId");
          } else {
            this.$toast({
              message: res.msg,
              duration: 1000
            });
          }
        });
      } else {
        //线下支付
        OrderCreate(data).then(res => {
          if (res.status == 200) {
            this.$router.push({
              name: "offline-pay",
              query: {
                sno: res.data
              }
            });
            sessionStorage.removeItem("shopId");
          } else {
            this.$toast({
              message: res.msg,
              duration: 1000
            });
          }
        });
      }
    }
  },

  computed: {
    //计算总价
    total() {
      let total = 0;
      this.productList.forEach(el => {
        total += el.price * el.qty;
      });
      this.totalPrice = total;
      return total;
    },
    //计算运费
    freight() {
      let price = 0;
      //小于500 或者自提时运费为0
      if (this.totalPrice > 500 || this.address.lifiting) {
        price = 0;
      } else {
        //省外运费23 省内市内13 省内市内区内12
        price =
          this.address.provinceCode != 440000
            ? 23
            : this.address.cityCode != 440300
            ? 13
            : 12;
      }
      this.freightPrice = price;
      return price;
    }
  }
};
</script>

<style lang="less" scoped>
.payment {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.choose-address {
  min-height: 170px;
  position: relative;
  background: #fff;
  padding: 20px 0;
  .bottom-icon {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .right-icon {
    position: absolute;
    top: 40%;
    right: 30px;
    height: 30px;
    width: 30px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .no-address {
    text-align: center;
    margin-top: 40px;
    p:nth-child(1) {
      font-size: 26px;
      color: #999;
    }
    p:nth-child(2) {
      font-size: 22px;
      color: #fc5400;
      margin-top: 15px;
    }
  }
  .address-content {
    margin-left: 30px;
    .name {
      color: #333;
      font-size: 30px;
    }
    .address {
      color: #666;
      font-size: 24px;
      width: 599px;
      line-height: 40px;
      margin: 10px 0;
    }
    .self-mention {
      font-size: 22px;
      color: #fc5400;
    }
  }
}
// 商品列表
.product-list {
  margin: 20px 0;
  .brand {
    color: #666;
    font-size: 26px;
    line-height: 40px;
  }
}
.van-card__thumb {
  width: 150px;
  height: 150px;
  margin-right: 20px;
  border: 1px solid #f2f2f2;
}
.van-card {
  padding: 20px 30px;
  background: #fff;
}
.van-card__title {
  font-size: 30px;
  color: #333;
  line-height: 40px;
  margin-bottom: 5px;
  max-height: 5.267vw;
}
.van-card__price {
  font-size: 26px;
  color: #ff6600;
  margin-top: 12px;
}

.van-card:not(:first-child) {
  margin-top: 0;
  border-top: 1px solid #f2f2f2;
}
// 发票
.choose-invoice {
  width: 100%;
  height: 86px;
  line-height: 86px;
  color: #333;
  font-size: 28px;
  padding: 0 30px;
  box-sizing: border-box;
  background: #fff;
  p {
    float: right;
    width: 516px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
  }
  .icon {
    float: right;
    height: 30px;
    width: 30px;
    margin: 6px 0 0 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
// 留言
.leave-comments {
  width: 100%;
  height: 86px;
  line-height: 86px;
  color: #333;
  font-size: 28px;
  padding: 0 30px;
  box-sizing: border-box;
  background: #fff;
  margin: 20px 0;
  input {
    float: right;
    width: 500px;
    height: 50px;
    line-height: 50px;
    padding: 18px 0;
    font-size: 24px;
  }
}
// 价格运费
.price-wrap {
  background: #fff;
  padding: 30px;
  color: #333;
  ul {
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 20px;
    li {
      font-size: 28px;
      line-height: 50px;
      p {
        display: inline-block;
      }
      span {
        color: #ff6600;
        float: right;
      }
    }
  }
  .total {
    font-size: 34px;
    text-align: right;
    padding-top: 20px;
    span {
      color: #ff6600;
      font-size: 30px;
    }
  }
}
// 支付方式
.chosse-payment {
  margin-top: 20px;
  background: #fff;
  font-size: 28px;
  padding: 0 30px;
  ul {
    li {
      width: 100%;
      height: 98px;
      line-height: 98px;
      .type-icon {
        width: 40px;
        height: 40px;
        margin-right: 30px;
        display: inline-block;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    li:first-child {
      .type-icon {
        width: 28px;
        margin-right: 42px;
      }
    }
    li:not(:last-child) {
      border-bottom: 1px solid #f2f2f2;
    }
  }
  img {
    vertical-align: middle;
  }
  .radio-icon {
    width: 60px;
    height: 60px;
    float: right;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
// 底部
.payment-footer {
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 106px;
  line-height: 106px;
  border-top: 1px solid #f2f2f2;
  background: #fff;
  z-index: 99;
  font-size: 28px;
  p {
    width: 460px;
    padding-left: 30px;
    span {
      color: #ff6600;
      font-size: 36px;
    }
  }
  button {
    flex: 1;
    background: #ff6600;
    color: #fff;
    font-size: 36px;
    border: none;
  }
}
</style>